export const registerSubmitRef = ({ refVariable, activeViewType, formId, buttonRefElement }) => {
  try {
    if (!refVariable) return;
    if (activeViewType === 'multiple') {
      if (!refVariable.current || typeof refVariable.current !== 'object') {
        refVariable.current = {};
      }
      refVariable.current[formId] = buttonRefElement;
    } else {
      refVariable.current = buttonRefElement;
    }
  } catch (err) {
    // swallow - defensive
  }
};
